import { useState } from 'react';
import mockApi from '../api/mockApi';

export default function useChargerStatus() {
    const [chargerStatus, setChargerStatus] = useState({
		slimpark01: [],
		slimpark02: [],
        slimpark03: [],
		slimpark04: [],
	});

    const getChargerStatus = async () => {
        try {
            setChargerStatus(
			prevState => ({
                ...prevState,
                slimpark01: [],
                slimpark02: [],
                slimpark03: [],
                slimpark04: [],
			}));
        } catch (error) {
            console.log(error)
        }
    };

    return {chargerStatus: chargerStatus, getChargerStatus: getChargerStatus};
};
